module.exports = __webpack_public_path__ + "static/media/send-letter-info-img2@2x.3298f5fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/send-letter-info-img2@2x.png
// module id = 1314
// module chunks = 1